export default {
  userData: {
    phone: '',
    firstName: '',
    birthday: '',
    email: '',
    gender: 0,
    Balance: 0,
    CartCount:20,
    deliveryAddresses: [],
    LegalTypes: [],
    legals: [],
    Garage: [],
    NewPhone: '',
    socialNetworks: [],
    Transactions : {},
    InmotionsCount: 0,
    Inmotions: [],
    headUserName: "alx kononov",
    headUserLevel: 6,
    currentLevel: 6,
    refId: '6013c70e-a6d3-2a21-d13a-90b6e7737d60',
    currentPoints: 100,
    currentPointsDiff: 0,
    groupPoints: 100,
    groupPointsDiff: -1,
    personalPoints: 10000,
    personalPointsDiff: 10,
    Roles: 'MlmMember',
    invites : [
      {
        "contact": "+79999999999",
        "invitationDate": "02.03.2017 20:32:25",
        "invitedUserId": 21,
        "state": 1
      },
      {
        "contact": "mymail@email.com",
        "invitationDate": "01.03.2017 20:32:25",
        "invitedUserId": 21,
        "state": 1
      }
    ],
    groupData: [
      {
        userId: 47,
        currentLevel: 9,
        userName: "Test",
        joinDate: "2017-02-25T00:00:00",
        detalization: [
          {
            type: 1,
            points: 1000,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 2,
            year: 2017
          },
          {
            type: 1,
            points: 2000,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 1,
            year: 2017
          },
          {
            type: 1,
            points: 7000,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 12,
            year: 2016
          },
          {
            type: 1,
            points: 120,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 11,
            year: 2016
          },
          {
            type: 1,
            points: 130,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 10,
            year: 2016
          }
        ]
      },
      {
        userId: 47,
        userName: "Test2",
        currentLevel: 6,
        joinDate: "2017-03-25T00:00:00",
        detalization: [
          {
            type: 1,
            points: 10020,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 2,
            year: 2017
          },
          {
            type: 1,
            points: 22000,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 1,
            year: 2017
          },
          {
            type: 1,
            points: 27000,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 12,
            year: 2016
          },
          {
            type: 1,
            points: 1202,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 11,
            year: 2016
          },
          {
            type: 1,
            points: 13220,
            date: "2017-02-27T02:35:11.161695+05:00",
            month: 10,
            year: 2016
          }
        ]
      }
    ]
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/User/redux/userState.js
 **/